import { CSSObject, Theme } from '@mui/material';

export const sectionExpandIconWrapperSx = (theme: Theme): CSSObject => ({
  width: '1.75rem',
  height: '1.75rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  color: theme.palette.text.secondary,
  transform: 'rotate(-90deg)',
  transition: theme.transitions.create(['transform', 'background-color'], {
    duration: 150,
  }),
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&.Mui-expanded': {
    transform: 'rotate(0deg)',
  },
  '& .material-symbols-outlined, & svg': {
    fontSize: '1.25rem',
  },
});
